import React, { Component } from "react";
import Layout from "../../layouts/Layout";

import { StyledCircularProgress } from "../../styles/StyledComponents";
import NoData from "../../styles/Illustrations/NoData";

import { EndPoints } from "../../utils/EndPoints";
import { Paper } from "@material-ui/core";
import Icon from "@mui/material/Icon";
import { ModeEdit } from "@mui/icons-material";
import Tooltip from "@material-ui/core/Tooltip";

import Popup from "./components/Popup";
import EditForm from "./components/EditForm";
import NewForm from "./components/NewForm";
import moment from "moment";
import { getSingleModule_widget } from "../../Regex";
import { accessText } from "../../routes/sidebar";

export class ContractTypesComponent extends Component {
  constructor(props) {
    const templateTabs = [
      {
        label: EndPoints["ContractTypes"],
        tooltip: `Click to approve pending ${EndPoints["ContractTypes"]}`,
        data: [],
        route: `/ContractTypes/${EndPoints["ContractTypes"].split("/")[0]}`,
        goBackRoute: "/ContractTypes",
        primaryField: "contract_type",
        primarySecondValue: "total_net_weight",
        primaryFieldFallback: "total_trips", // Optional
        secondaryField: "is_active",
        primaryFieldThirdFallback: "total_net_weight_pending_trips",
        avatarField: "src",

        decorators: {
          conditionField: "status",
          options: ["pending", "approved", "unidentified"],
          colors: ["yellow", "#0AFF00", "#FF3D00"],
        },
      },
    ];
    super(props);
    this.setStateOfPopup.bind(this);
    this.state = {
      tabs: templateTabs,
      ContractTypes: [],
      singlelistView: null,
      loading: false,
      isPopup: false,
      isNew: false,
    };
  }

  setStateOfPopup = (value) => {
    this.setState({ isPopup: value, isNew: false });
  };

  UNSAFE_componentWillReceiveProps(next) {
    this.setInitialValues(next);
  }
  UNSAFE_componentWillMount() {
    const next = this.props;
    if (next.params && next.params.tab) {
      let tab = next.params.tab;
      if (tab === EndPoints["ContractTypes"] && next.params.id) {
        this.setState(
          {
            singlelistView: this.state.tabs[0].data[next.params.id],
          },
          () => {
            if (this.state.singlelistView && this.state.singlelistView.id) {
              this.props.ContractTypesFunction(
                "get",
                EndPoints["ContractTypes"],
                this.state.singlelistView.id,
                "ContractTypes"
              );
            }
          }
        );
      } else if (tab === "NEW") {
        this.setState({ singlelistView: null });
      }
    } else {
      this.setState({ singlelistView: null });
    }
    this.setInitialValues(this.props);
  }

  listClickHandler = (value) => {
    this.setState(
      {
        singlelistView: value,
      },
      () => {
        // if (this.state.singlelistView && this.state.singlelistView.id) {
        //   this.props.ContractTypesFunction(
        //     "get",
        //     EndPoints["ContractTypes"],
        //     this.state.singlelistView.id,
        //     "ContractTypes"
        //   );
        // }
      }
    );
  };
  searchHandler = (value) => {
    this.listClickHandler(value);
    // if (value && value.monthId) {
    //   if (this.state.selectedMonth.monthId !== value.monthId) {
    //     this.setState({ selectedMonth: value, singleDate: null, singleDateTrips: [], singleDateTripsCopy: [] });
    //     this.props.fetchlistViewArray(this.props.user.user.uid, value.monthId, value.yearId).then((dateRR) => {
    //       this.props.setlistViewArray(dateRR);
    //     });
    //   }
    // }
  };
  setInitialValues(props) {
    const { widget_permission } = getSingleModule_widget(
      props.user,
      accessText.purchase_order,
      accessText.contract_type
    );
    const tabs = this.state.tabs.map((e, i) => {
      const tab = e;
      // has_read_permission:true,has_create_permission:true
      tab.widget = widget_permission?.widget
        ? { ...widget_permission?.widget }
        : null;
      tab.data =
        props[EndPoints["ContractTypes"]] && props[EndPoints["ContractTypes"]].length > 0
          ? props[EndPoints["ContractTypes"]].sort((a, b) => {
              var dateA = moment(b.created_at).format("MMM D YYYY h:mm:ss A");
              var dateB = moment(a.created_at).format("MMM D YYYY h:mm:ss A");
              return new Date(dateA) - new Date(dateB);
            })
          : [];
      return tab;
    });
    this.setState({
      listViewArray:
        props[EndPoints["ContractTypes"]] && props[EndPoints["ContractTypes"]].length > 0
          ? props[EndPoints["ContractTypes"]].sort((a, b) => {
              var dateA = moment(b.created_at).format("MMM D YYYY h:mm:ss A");
              var dateB = moment(a.created_at).format("MMM D YYYY h:mm:ss A");
              return new Date(dateA) - new Date(dateB);
            })
          : [],
      ContractTypes: props.ContractTypes,
      tabs,
      loading: props.loading,
    });
  }
  render() {
    const { tabs, listViewArray, singlelistView, loading } = this.state;
    // const { isMobile ,user} = this.props;
    var labelField = "contract_type";
    // if (listViewArray && listViewArray.length > 0 && listViewArray[0]) {
    //   Object.keys(listViewArray[0]).map((sKey) => {
    //     if (typeof listViewArray[0][sKey] === "string") {

    //       return (labelField = sKey);
    //     } else {
    //       return null;
    //     }
    //   });
    //   // labelField="" //assign search field
    // }
    return (
      <Layout
        loading={loading[EndPoints["ContractTypes"]]}
        tabs={tabs}
        noTab={true}
        RaisedSearchBar={{
          data: listViewArray && listViewArray.length > 0 ? listViewArray : [],
          hintText: `Search Contract Types`,
          labelField: labelField,
        }}
        listClickHandler={this.listClickHandler}
        fabClickHandler={() => {
          this.setState({
            isPopup: true,
            isNew: true,
          });
        }}
        serchClick={this.searchHandler}
        centerWidth="230px"
        openWidth="465px"
        closeWidth="287px"
      >
        <Paper
          className="width-100 height-100 padding15 backgroundWhite"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {singlelistView === null ? (
            <div className="d-flex width-100 height-100 justifyC alignC">
              <NoData />
            </div>
          ) : loading.ContractTypes === true ? (
            <div className="alignC justiyC d-flex width-100 height-100">
              <StyledCircularProgress color="inherit" />
            </div>
          ) : (
            <>
              <div style={{ width: "90%" }}>
                <h1 style={{ fontWeight: "400", fontSize: "25px" }}>Contract Details</h1>
              </div>
              <Paper
                className="padding15 backgroundWhite"
                style={{
                  width: "90%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "50px",
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingRight: "4%",
                  }}
                >
                  <Tooltip title="Edit">
                    <Icon
                      onClick={() => this.setState({ isPopup: true })}
                      style={{ cursor: "pointer" }}
                      component={ModeEdit}
                    />
                  </Tooltip>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 50px",
                    paddingBottom: "25px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ fontSize: "18px", margin: "8px 0" }}>Contract Type: </p>
                    <p
                      style={{
                        fontSize: "18px",
                        marginLeft: "10px",
                        color: "#808080",
                        margin: "8px 10px",
                      }}
                    >
                      {singlelistView.contract_type}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ fontSize: "18px", margin: "8px 0" }}>Status: </p>
                    <p
                      style={{
                        fontSize: "18px",
                        marginLeft: "10px",
                        color: "#808080",
                        margin: "8px 10px",
                      }}
                    >
                      {singlelistView.is_active ? "Active" : "Inactive"}
                    </p>
                  </div>
                </div>
              </Paper>
            </>
          )}
        </Paper>
        <Popup isNew={this.state.isNew} openPopup={this.state.isPopup} setOpenPopup={this.setStateOfPopup}>
          {this.state.isNew ? (
            <NewForm
              closePopup={this.setStateOfPopup}
              getFn={
                (res) => this.props.ContractTypesFunction("get", EndPoints["ContractTypes"])
                .then((res) => {
                  if (res) {
                    this.setState({ singlelistView: res });
                  }
                })
              }
            />
          ) : (
            singlelistView !== null && (
              <EditForm
                getFn={(response) => {
                  if (response.data) {
                    this.setState({ singlelistView: response.data });
                  }
                  this.props.ContractTypesFunction("get", EndPoints["ContractTypes"]);
                  if (response.data.is_active === false) {
                    this.setState({ singlelistView: null });
                    this.setStateOfPopup(false);
                  }
                  this.props
                    .ContractTypesFunction(
                      "get",
                      "masters/contract-type",
                      singlelistView.id,
                      "ContractTypes"
                    )
                    .then((res) => {
                      if (res) {
                        this.setState({ singlelistView: res });
                      }
                    })
                }}
                id={singlelistView.id}
                contractType={singlelistView.contract_type}
                status={singlelistView.is_active}
                closePopup={this.setStateOfPopup}
              />
            )
          )}
        </Popup>
      </Layout>
    );
  }
}

export default ContractTypesComponent;
